import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow">
      <div className="flex items-center justify-between px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex items-center">
          <h1 className="text-xl font-bold text-gray-900">
            {process.env.NODE_ENV === 'development'
              ? 'InventApp - Entorno Dev'
              : 'InventApp'}
          </h1>
        </div>

        {user && (
          <div className="flex items-center space-x-4">
            <div className="text-sm text-gray-700">
              <div className="flex items-center gap-2">
                <span className="font-medium">{user.name}</span>
                {user.isAdmin === 1 ? (
                  <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                    Admin
                  </span>
                ) : user.profileId === 3 ? (
                  <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    Manager
                  </span>
                ) : user.profileId === 7 ? (
                  <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
                    Usuario
                  </span>
                ) : null}
              </div>
              {user.shopId && (
                <div className="mt-1 text-gray-500">({user.shopName})</div>
              )}
            </div>
            <button
              onClick={handleLogout}
              className="px-1 py-1 text-sm text-white bg-red-600 rounded-md hover:bg-red-700"
            >
              Salir
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;